// Utility class to handle date and time stuff
export default class timeguy {
  // Methods
  // returns current time as UNIX timestamp
  static now(): number {
    return new Date().getTime();
  }
}
